import { Bell } from 'react-feather'

import { notificationIcon } from '@src/utility/notificationIcons'

const NoticeIcon = notificationIcon('ANNOUNCEMENT')
const NewsIcon = notificationIcon('NEWS')
const MessageIcon = notificationIcon('OFFICER_MESSAGE')
const ReminderIcon = notificationIcon('RENEWAL_DUE')

// One "Notifications" group. It has no permission of its own, so it shows
// when the user can open at least one of these; each keeps its own check.
export default [
  {
    id: 'notifications',
    title: 'Notifications',
    icon: <Bell size={20} />,
    children: [
      {
        id: 'announcements',
        title: 'Announcements',
        icon: <NoticeIcon size={12} />,
        navLink: '/announcements',
        action: 'read',
        resource: 'Announcement'
      },
      {
        id: 'news',
        title: 'News',
        icon: <NewsIcon size={12} />,
        navLink: '/news',
        action: 'read',
        resource: 'News'
      },
      {
        id: 'messages',
        title: 'Messages',
        icon: <MessageIcon size={12} />,
        navLink: '/messages',
        action: 'read',
        resource: 'Message'
      },
      {
        id: 'reminders',
        title: 'Reminders',
        icon: <ReminderIcon size={12} />,
        navLink: '/reminders',
        action: 'read',
        resource: 'Reminder'
      }
    ]
  }
]
